import {
  PostData,
} from '../@types/postData'

import {
  ModalElements,
} from '../@types/elements'

import {
  getPostData,
} from './fetch'

import {
  doAdjacentPostMarkup,
  doModalMarkup,
  doImageMarkup,
  getRequiredElement,
  getRequiredElements,
} from './markup'

export const closeModalClickHandler = (evt: MouseEvent, modalElements: ModalElements) => {
  evt.preventDefault()
  modalElements.readerModal.classList.add('uctoday-reader-modal-closed')
}

export const closeModalKeyHandler = () => {
  const openModals = getRequiredElements<HTMLElement>(document, '.uctoday-reader-modal:not(.uctoday-reader-modal-closed)')

  if (!openModals) {
    return
  }

  openModals.forEach((modal) => modal.classList.add('uctoday-reader-modal-closed'))
}

export const readerModeHandler = async (evt: MouseEvent | KeyboardEvent, modalElements: ModalElements) => {
  evt.preventDefault()

  let fetchError = false
  let withData = null
  let adjacentPostData = null
  let selfHref = ''
  const target = evt.target as HTMLElement | null
  if (!target) {
    return
  }
  const postWrapper = modalElements.postWrapper
  const loadingEl = modalElements.loadingWrapper
  
  if (evt.type === 'click' && target.dataset.selfHref !== undefined) {
    selfHref = target.dataset.selfHref
  } else if (evt.type === 'click') {
    withData = target.closest<HTMLElement>('.uctoday-has-data')
    selfHref = withData?.dataset.selfHref ?? ''
  } else if (evt.type === 'keydown') {
    const keyEvent = evt as KeyboardEvent
    switch (keyEvent.key) {
      case 'ArrowLeft':
        selfHref = modalElements.modalPrevious.dataset.selfHref ?? ''
        break
      case 'ArrowRight':
        selfHref = modalElements.modalNext.dataset.selfHref ?? ''
        break
      default:
        return
    }
  } else {
    return
  }

  try {
    modalElements.readerModal.classList.remove('uctoday-reader-modal-closed')
    loadingEl.style.display = 'block'
    postWrapper.style.display = 'none'
    if (selfHref === '') {
      return
    }
    const postData = await getPostData(`${selfHref}?_embed`)
    withData = getRequiredElement<HTMLElement>(document, `[data-id="${postData.id}"]`)
    if (!withData) {
      return
    }
    adjacentPostData = JSON.parse(withData.dataset.adjacentPosts ?? '') as PostData['_links']['adjacent-posts']
    postData._links['adjacent-posts'] = adjacentPostData
    doAdjacentPostMarkup(withData, modalElements.modalPrevious, modalElements.modalNext)
    doModalMarkup(postData, modalElements)
    doImageMarkup(modalElements.modalContent)
  } catch (err) {
    fetchError = true
    console.error(err)
  } finally {
    loadingEl.style.display = 'none'
    postWrapper.style.display = 'block'
  }

  // if there's a problem fetching the post data, try to navigate to the post
  if (fetchError) {
    loadingEl.style.display = 'block'
    loadingEl.innerHTML = `<div style="padding: 20px;">
      <p style="font-size: 48px; color: #fff;">There was a problem loading this post.</p>
      <p style="font-size: 24px; color: #fff;">You will be redirected to the post in a moment.</p>
    </div>`
    fetch(selfHref)
      .then((res) => res.json())
      .then(({ link }) => window.location.href = link)
      .catch((err) => console.error(err))
  }
}